import {
    DISPATCHER_LISTS_VIEW_PERMISSION,
    STAFF_ORDER_EDIT_PERMISSION,
} from '@/constants/permissions'

export default [
    {
        path: '/dispatcher',
        name: 'dispatcher',
        meta: {
            permission: [DISPATCHER_LISTS_VIEW_PERMISSION],
            isRedesigned: true,
            allowMobile: true,
            isDispatcher: true,
        },
        component: () => import('./views/Dispatcher.vue'),
    },
    {
        path: '/dispatcher/staff',
        name: 'staff-order-new',
        meta: {
            permission: [STAFF_ORDER_EDIT_PERMISSION],
            allowMobile: true,
            isDispatcher: true,
        },
        component: () => import('@/views/orders-edit/Order.vue'),
    },
    {
        path: '/dispatcher/:id',
        name: 'dispatcher-order-details',
        meta: {
            permission: [DISPATCHER_LISTS_VIEW_PERMISSION],
            isRedesigned: true,
            allowMobile: true,
            isDispatcher: true,
        },
        component: () => import('./views/DispatcherOrder.vue'),
    },
    {
        path: '/dispatcher/staff/:id',
        name: 'staff-order-details',
        meta: {
            permission: [STAFF_ORDER_EDIT_PERMISSION],
            allowMobile: true,
            isDispatcher: true,
        },
        component: () => import('@/views/orders-edit/Order.vue'),
    },
]
